import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = (props) => {
   if (!localStorage.getItem('username')) {
      return <Redirect to='login' />;
   } else {
      return <Route {...props} />;
   }
};

export default ProtectedRoute;
